import { newThemeOptions } from 'src/theme/theme';

export const typographyArray = [
  {
    style: newThemeOptions.newTypography.textStyleDisplaySpecial,
    typestyle: 'Display-Special',
    token: 'textStyleDisplaySpecial',
  },
  {
    style: newThemeOptions.newTypography.textStyleDisplayXLarge,
    typestyle: 'Display-X-Large',
    token: 'textStyleDisplayXLarge',
  },
  {
    style: newThemeOptions.newTypography.textStyleDisplayLarge,
    typestyle: 'Display-Large',
    token: 'textStyleDisplayLarge',
  },
  {
    style: newThemeOptions.newTypography.textStyleDisplayMedium,
    typestyle: 'Display-Medium',
    token: 'textStyleDisplayMedium',
  },
  {
    style: newThemeOptions.newTypography.textStyleDisplaySmall,
    typestyle: 'Display-Small',
    token: 'textStyleDisplaySmall',
  },
  {
    style: newThemeOptions.newTypography.textStyleHeading,
    typestyle: 'Heading',
    token: 'textStyleHeading',
  },
  {
    style: newThemeOptions.newTypography.textStyleSubheading,
    typestyle: 'Subheading',
    token: 'textStyleSubheading',
  },
  {
    style: newThemeOptions.newTypography.textStyleBodyLarge,
    typestyle: 'Body-Large',
    token: 'textStyleBodyLarge',
  },
  {
    style: newThemeOptions.newTypography.textStyleBodyLargeSemibold,
    typestyle: 'Body-Large-Semibold',
    token: 'textStyleBodyLargeSemibold',
  },
  {
    style: newThemeOptions.newTypography.textStyleBody,
    typestyle: 'Body',
    token: 'textStyleBody',
  },
  {
    style: newThemeOptions.newTypography.textStyleBodySemibold,
    typestyle: 'Body-Semibold',
    token: 'textStyleBodySemibold',
  },
  {
    style: newThemeOptions.newTypography.textStyleBodySmall,
    typestyle: 'Body-Small',
    token: 'textStyleBodySmall',
  },
  {
    style: newThemeOptions.newTypography.textStyleBodySmallSemibold,
    typestyle: 'Body-Small-Semibold',
    token: 'textStyleBodySmallSemibold',
  },
];
